import { IBillsState } from './bills.types'

export const BillsState: IBillsState = {
  loaders: {
    fetchBillsByCustomer: false
  },
  bills: null,
  hasMore: true
}
